// extracted by css-extract-rspack-plugin
export default {"item":"g_kPx"};